import { render } from "./authorityManage.vue?vue&type=template&id=14ecc982&scoped=true"
import script from "./authorityManage.vue?vue&type=script&lang=js"
export * from "./authorityManage.vue?vue&type=script&lang=js"

import "./authorityManage.vue?vue&type=style&index=0&id=14ecc982&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14ecc982"]])

export default __exports__